import type { AxiosResponse } from "axios";
import type { ActivityResponse } from "src/container/Customers/DriverActivities/driverActivities";
import { ServicesUrlEndpoints } from "src/services/servicesEndpointConstant";
import ApiService from "src/util/api.service";

export interface DriverLookupItem {
  id: number | string;
  name?: string;
  surname?: string;
  customerId?: number | string;
  clientId?: number | string;
  customer?: { id?: number | string };
}

interface DriverLookupResponse {
  response?: DriverLookupItem[];
}

interface DriverActivitiesApiResponse {
  response?: ActivityResponse;
}

export const getDriverActivitiesLookup = (
  params: Record<string, unknown>,
): Promise<AxiosResponse<DriverLookupResponse>> =>
  ApiService.get(ServicesUrlEndpoints.DRIVER_ACTIVITIES.DRIVER_LOOKUP, { params });

export const getDriverActivities = (
  params: Record<string, unknown>,
): Promise<AxiosResponse<DriverActivitiesApiResponse>> =>
  ApiService.get(ServicesUrlEndpoints.DRIVER_ACTIVITIES.ACTIVITY, { params });
